export interface PasswordRequirement {
  label: string;
  met: boolean;
}

/** Which meaning the filled bars carry: weak, getting there, strong. */
function strengthTone(score: number): string {
  if (score <= 1) {
    return "bg-destructive";
  }
  if (score <= 3) {
    return "bg-caution";
  }
  return "bg-positive";
}

/**
 * How strong the password is so far: four bars that fill as requirements are
 * met, over the list of the requirements themselves. One component, because the
 * sign-up form and the reset-password page show the same thing.
 */
export function PasswordStrength({ label, requirements, score }: { label: string; requirements: PasswordRequirement[]; score: number }) {
  const tone = strengthTone(score);

  return (
    <div className="rounded-card bg-muted p-inset-lg">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-h4">{label}</span>
        <div className="flex gap-1">
          {[1, 2, 3, 4].map((step) => (
            <div className={`h-1.5 w-6 rounded-full ${step <= score ? tone : "bg-muted-foreground/25"}`} key={step} />
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        {requirements.map((requirement) => (
          <div className={`flex items-center gap-2 text-meta ${requirement.met ? "text-positive" : "text-muted-foreground"}`} key={requirement.label}>
            <div className={`h-1.5 w-1.5 rounded-full ${requirement.met ? "bg-positive" : "bg-muted-foreground/40"}`} />
            <span>{requirement.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
